import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { BannerVideoImageComponent } from './banner-video-image.component'
import { BlogViewComponent } from './blog-view/blog-view.component'
import { NewViewComponent } from './new-view/new-view.component'
import { EventViewComponent } from './event-view/event-view.component'
import { SharedModule } from '../shared/shared.module'
import { CarouselModule } from 'ngx-owl-carousel-o'
import { SlideViewComponent } from './slide-view/slide-view.component'
import { NgxJsonLdModule } from 'ngx-json-ld'
import { BasicViewComponent } from './basic-view/basic-view.component'



@NgModule({
  declarations: [BannerVideoImageComponent, BlogViewComponent, NewViewComponent, EventViewComponent, SlideViewComponent, BasicViewComponent],
  imports: [
    CommonModule,
    SharedModule,
    CarouselModule,
    NgxJsonLdModule
  ],
  exports: [BannerVideoImageComponent]
})
export class BannerVideoImageModule { }
